import { LaserMachine } from '../types';

export type MachineLicenseKey = 'updateService' | 'serviceContract' | 'arturo';

export const MACHINE_LICENSES: { key: MachineLicenseKey; label: string; shortLabel: string }[] = [
  { key: 'updateService', label: 'Aggiornamenti HMI', shortLabel: 'Agg. HMI' },
  { key: 'serviceContract', label: 'Contratto di service', shortLabel: 'Service' },
  { key: 'arturo', label: 'Arturo', shortLabel: 'Arturo' },
];

export type LicenseStatus = 'ACTIVE' | 'EXPIRED' | 'DISABLED';

/** License date inputs represent calendar days in UTC, rather than local timestamps. */
export const formatLicenseDate = (value: Date | string) => new Date(value).toLocaleDateString('it-IT', { timeZone: 'UTC' });

export interface LicenseInfo {
  status: LicenseStatus;
  expiresAt: Date | null; // null = permanente
  text: string; // es. "ATTIVA fino al 31/12/2026", "PERMANENTE", "SCADUTA il ...", "NON ATTIVA"
  color: 'success' | 'warning' | 'default';
}

/** Stessa regola del backend: attiva se abilitata e senza scadenza o con scadenza futura. */
export function getLicenseInfo(machine: Partial<LaserMachine>, key: MachineLicenseKey): LicenseInfo {
  const enabled = !!machine[`${key}Enabled`];
  const rawExpiry = machine[`${key}ExpiresAt`];
  const expiresAt = rawExpiry ? new Date(rawExpiry as any) : null;

  if (!enabled) return { status: 'DISABLED', expiresAt, text: 'NON ATTIVA', color: 'default' };
  if (!expiresAt) return { status: 'ACTIVE', expiresAt, text: 'PERMANENTE', color: 'success' };
  if (expiresAt > new Date()) {
    return { status: 'ACTIVE', expiresAt, text: `ATTIVA fino al ${formatLicenseDate(expiresAt)}`, color: 'success' };
  }
  return { status: 'EXPIRED', expiresAt, text: `SCADUTA il ${formatLicenseDate(expiresAt)}`, color: 'warning' };
}
